import {FINANCE_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getContactsList: function ({limit = 9999, page = 1, contactType = 1}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + (VueCookie.get('token') || ''),
        'company': VueCookie.get('company')
      }
    })
    const fullRequest = [`page=${page}`, `limit=${limit}`, 'sort[]=nickName', `contactType[]=${contactType}`]
    return instCred.get('clients/withoutelastic?' + fullRequest.join('&'))
  }
}



// WEBPACK FOOTER //
// ./src/api/Contacts/api.js